<app-theme-selector [hideUI]="true"></app-theme-selector>
<div *ngIf="showSweepLine" class="ai-sweep-line" style="position: fixed; z-index: 9999"></div>
<mat-sidenav-container>
    <mat-sidenav #sidenav mode="over">
        <div fxLayout="column">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <img mat-card-avatar [src]="user.avatarURL" />
                </mat-card-header>
                <mat-card-content>
                    <a fxLayout="row" fxLayoutAlign="space-between center" (click)="switchNav()">
                        <div>
                            <mat-card-title>{{ user.username }}</mat-card-title>
                            <mat-card-subtitle>{{ user.businessName }}</mat-card-subtitle>
                        </div>
                        <div style="width: 24px;">
                            @if (primaryNav) {
                                <mat-icon color="primary">arrow_drop_down</mat-icon>
                            }
                            @if (!primaryNav) {
                                <mat-icon>arrow_drop_up</mat-icon>
                            }
                        </div>
                    </a>
                </mat-card-content>
            </mat-card>

            <div class="exp-select-container">
                <mat-icon class="exp-trigger-icon"> {{ experienceLevel | experienceIcon }}</mat-icon>
                <mat-select [(ngModel)]="experienceLevel"
                            (selectionChange)="onExperienceLevelChange($event)"
                            [panelClass]="'exp-dropdown-panel'"
                            class="exp-select-input">
                    <mat-option *ngFor="let option of skillOptions" [value]="option.value" class="exp-option-item">
                        <mat-icon class="exp-option-icon">{{ option.value | experienceIcon }}
                        </mat-icon>
                        <span class="exp-option-text colorDropLevel">{{ option.label | transloco }}</span>
                    </mat-option>
                </mat-select>
            </div>

            @if (primaryNav) {
                <app-nav (routerClick)="sidenav.close()" (whenMinimized)="sidenav.close();"
                         (whenClosed)="sidenav.close()"></app-nav>
            }
            @if (!primaryNav) {
                <mat-nav-list>
                    <h3 matSubheader>
                        {{ 'navigation.account' | transloco }}
                    </h3>
                    <a mat-list-item routerLink="/orders" routerLinkActive="active" (click)="sidenav.close()">
                        <mat-icon>account_circle</mat-icon>
                        <span class="header-nav-menu">{{ 'navigation.account' | transloco }}</span>
                    </a>
                    <a mat-list-item (click)="logout()">
                        <mat-icon>directions_run</mat-icon>
                        <span class="header-nav-menu">{{ 'navigation.logout' | transloco }}</span>
                    </a>
                </mat-nav-list>
            }
        </div>
    </mat-sidenav>
    <mat-sidenav-content>
        <mat-toolbar color="primary">
            <button mat-icon-button class="sidenav-button hide-gt-sm" (click)="sidenav.open()">
                <mat-icon>menu</mat-icon>
            </button>
            <div style="z-index: 1" fxFlex="auto" class="brand">
                <app-header></app-header>
                <h3 class="studioVersion montserratFamily" matSubheader style="padding-left: 10px">
                    @if (activeSceneId) {
                        <span class="scene-name">{{ activeSceneName }}</span>

                    } @else {
                        <span class="iconPlan hide-lt-md">
                            @switch (accountVer) {
                                @case ('FREE') {
                                    <mat-icon>auto_awesome</mat-icon>
                                }
                                @case ('PLUS') {
                                    <mat-icon>star_border</mat-icon>
                                }
                                @case ('ENTERPRISE_08') {
                                    <mat-icon>star_border</mat-icon>
                                }
                                @case ('ENTERPRISE_24') {
                                    <mat-icon>star_border</mat-icon>
                                }
                                @case ('dashboard') {
                                    <mat-icon>local_police</mat-icon>
                                }
                            }
                        </span>
                        <span class="hide-lt-md">{{ versionText }}</span>
                    }
                </h3>
            </div>

            <!-- <mat-icon class="maxButton" fxShow.lt-md="false" (click)="onMaximized()" *ngIf="minimized" fxShow="true" fxShow.lt-md="false">skip_next</mat-icon> -->
            @if (showProgress) {
                <div style="height: 100%;padding-top: 6px;">
                    <circle-progress
                        [percent]="uploadingPercent"
                        [maxPercent]="100"
                        [radius]="18"
                        [outerStrokeWidth]="4"
                        [innerStrokeWidth]="2"
                        [space]="2"
                        [titleFontSize]="'9'"
                        [outerStrokeColor]="'#78C000'"
                        [innerStrokeColor]="'#C7E596'"
                        [animationDuration]="300"
                        [showSubtitle]="false"
                        [titleColor]="'#FFFFFF'"
                        [titleFontWeight]="'400'"
                        [startFromZero]="false"
                        [showUnits]="false"
                    ></circle-progress>
                </div>
            }

            <div class="hide-lt-sm">
                <!--
                <button mat-icon-button class="hide-lt-md left-menu-button ai-button"
                        [matTooltip]="aiVisible() ? 'Close AI Assistant' : 'Open AI Assistant'"
                        matTooltipPosition="below"
                        (click)="toggleAi($event)">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" [class.active]="aiVisible()">
                        <defs>
                            <linearGradient id="ai-toolbar-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" style="stop-color:#4A90E2;stop-opacity:1" />
                                <stop offset="100%" style="stop-color:#357ABD;stop-opacity:1" />
                            </linearGradient>
                        </defs>
                        <path d="M12 2 L20 7 L20 17 L12 22 L4 17 L4 7 Z" fill="url(#ai-toolbar-gradient)" stroke="#2C5AA0" stroke-width="1"/>
                        <text x="12" y="16" font-family="Arial, sans-serif" font-size="10" font-weight="bold" text-anchor="middle" fill="white">AI</text>
                    </svg>
                </button>
                -->


                @if (showHelpButton) {
                    <app-video-link [lessonMode]="true" videoLink="overview" [showBalloon]="true"
                                    [iconButton]="true"></app-video-link>
                }

                @if (upgradable) {
                    <button matTooltip="{{'navigation.upgrade' | transloco}}" mat-icon-button (click)="upgrade()"
                            class="hide-lt-md rocket">
                        <mat-icon style="color: red">rocket_launch</mat-icon>
                    </button>
                }
                @if (!liveChatStatus && (navChat$ | async) == '1') {
                    <button matTooltip="{{'account.liveChatOffLine' | transloco}}" mat-icon-button (click)="liveChat()"
                            class="left-menu-button">
                        <mat-icon>chat_bubble_outline</mat-icon>
                    </button>
                }
                @if (liveChatStatus && (navChat$ | async) == '1') {
                    <button matTooltip="{{'account.liveChatOnLine' | transloco}}" mat-icon-button (click)="liveChat()"
                            class="left-menu-button">
                        <mat-icon>chat</mat-icon>
                    </button>
                }
                @if (experienceLevel > experienceLevelType.BEGINNER) {
                    @if ((navSearch$ | async) == '1') {
                        <button matTooltip="{{'account.searchEverywhere' | transloco}}" mat-icon-button
                                (click)="globalSearch()" class="left-menu-button">
                            <mat-icon>search</mat-icon>
                        </button>
                    }
                }
                <!--            <button mat-icon-button (click)="downloadSignPlayer()" class="left-menu-button hide-lt-sm">-->
                <!--                <mat-icon matTooltip="{{'account.downloadPlayer' | transloco}}">download</mat-icon>-->
                <!--            </button>-->
                @if ((signStudioProducts$ | async) == '1') {
                    <button matTooltip="{{'account.onSale' | transloco}}" mat-icon-button (click)="openOnSale()"
                            class="hide-lt-md left-menu-button">
                        <mat-icon>sell</mat-icon>
                    </button>
                }
                @if (showHelpEnabled === '1' && (signStudioProducts$ | async) == '1') {
                    <button matTooltip="{{'navigation.shoppingCart' | transloco}}" mat-icon-button
                            class="hide-lt-md left-menu-button" routerLink="/shopping/list" routerLinkActive="active">
                        <mat-icon [matBadgeHidden]="cartTotal === 0" matBadge="{{cartTotal}}" matBadgeColor="warn" aria-hidden="false">
                            shopping_cart
                        </mat-icon>
                        <span class="cdk-visually-hidden"></span>
                    </button>
                }
            </div>

            <button mat-icon-button [matMenuTriggerFor]="headerActionMenu" class="hide-gt-xs">
                <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #headerActionMenu>
                <button mat-menu-item (click)="liveChat()" class="menuButton"
                        [matTooltip]="liveChatStatus ? ('account.liveChatOnLine' | transloco) : ('account.liveChatOffLine' | transloco)">
                    @if (!liveChatStatus && (navChat$ | async) == '1') {
                        <mat-icon>chat_bubble_outline</mat-icon>
                    }
                    @if (liveChatStatus && (navChat$ | async) == '1') {
                        <mat-icon>chat</mat-icon>
                    }
                    <span>{{ 'general.liveChat' | transloco }}</span>
                </button>
                @if ((navSearch$ | async) == '1') {
                    <button mat-menu-item (click)="globalSearch()" class="menuButton"
                            [matTooltip]="'account.searchEverywhere' | transloco">
                        <mat-icon>search</mat-icon>
                        <span>{{ 'general.search' | transloco }}</span>
                    </button>
                }
                @if ((signStudioProducts$ | async) == '1') {
                    <button mat-menu-item (click)="openOnSale()" class="menuButton">
                        <mat-icon matTooltip="{{'account.onSale' | transloco}}">sell</mat-icon>
                        <span>{{ 'account.onSale' | transloco }}</span>
                    </button>
                }
                @if (upgradable) {
                    <button color="warn" mat-menu-item (click)="upgrade()" class="menuButton">
                        <mat-icon style="color: red" matTooltip="{{'navigation.upgrade' | transloco}}">rocket_launch
                        </mat-icon>
                        <span>{{ 'navigation.upgrade' | transloco }}</span>
                    </button>
                }
                @if (showHelpEnabled === '1' && (signStudioProducts$ | async) == '1') {
                    <button mat-menu-item class="menuButton" routerLink="/shopping/list" routerLinkActive="active">
                        <mat-icon [matBadgeHidden]="cartTotal === 0" matBadge="{{cartTotal}}" matBadgeColor="warn" aria-hidden="false">
                            shopping_cart
                        </mat-icon>
                        <span>{{ 'account.cart' | transloco }}</span>
                    </button>
                }
            </mat-menu>

            <button mat-icon-button [matMenuTriggerFor]="profileMenu" class="hide-lt-md">
                @if (useAvatar === '0') {
                    <span matTooltip="{{ 'navigation.myAccount' | transloco }}">
                        <canvas style="position: relative; left: -10px; top: -8px" width="40" height="40"
                                [attr.data-jdenticon-value]="businessName"></canvas>
                    </span>
                }
                @if (useAvatar === '1') {
                    <span><img class="avatar" style="width: 40px; height: 40px" [src]="user.avatarURL" />
                        <span style="position: relative; top: -15px; left: 3px">{{ 'navigation.myAccount' | transloco }}</span>
                    </span>
                }
            </button>
            <mat-menu #profileMenu>
                <a mat-menu-item routerLink="/user"
                   routerLinkActive="active">{{ 'navigation.settings' | transloco }}</a>
                <button mat-menu-item (click)="logout()">{{ 'navigation.logout' | transloco }}</button>
            </mat-menu>
        </mat-toolbar>
        <div fxLayout="row" class="container">
            <!-- @if (activeSceneId == null) { -->
            @if (!navClosed) {
                <div [@slidePanel]="panelShownAnimation" class="nav hide-lt-md"
                     [ngStyle]="{'flex': '1 1 ' + navWidth, 'max-width': navWidth}">
                    <app-nav [minimized]="minimized" (whenMinimized)="onMinimized($event);"
                             (whenMaximized)="onMaximized()" (whenClosed)="onNavClosed()"></app-nav>
                </div>
            }
            <!-- } -->
            <div class="content" style="overflow: auto;">
                <div [@fadeIn]="childComponent">
                    <router-outlet outlet="main"></router-outlet>
                </div>
            </div>
        </div>

    </mat-sidenav-content>

</mat-sidenav-container>
<app-ai-prompt></app-ai-prompt>



